module.exports = __webpack_public_path__ + "static/media/008-circle-green.945a02f8.svg";